(function() {
    'use strict';

    angular.module('app.bloqueos', []);
})();
